import { ConstantVariables } from "../../../Helpers/ConstantVariables";
import { DataWarehouseDataService } from "../../../DataService/DataWarehouseDataService";
import { Toastr } from "../../../Helpers/Toastr";

export class GetAdditionalLineInformationManager {

    constructor(private containerElement: JQuery) { }

    private amountOfSelectedLinesTextSpan : JQuery<HTMLElement>;
    private selectAllLinesCheckbox : JQuery<HTMLElement>;

    private equipmentSectionOptionsContainer : JQuery<HTMLElement>;
    private selectAllEquipmentSectionButton : JQuery<HTMLElement>;
    private selectNoneEquipmentSectionButton : JQuery<HTMLElement>;

    private restoreOriginalDescriptionButton : JQuery<HTMLElement>;
    private updateDescriptionButton : JQuery<HTMLElement>;

    private shipServNameCheckbox: JQuery<HTMLElement>;
    private shipServDescriptionCheckbox: JQuery<HTMLElement>;
    private shipServManufacturerCheckbox: JQuery<HTMLElement>;
    private shipServModelNumberCheckbox: JQuery<HTMLElement>;
    private shipServRatingCheckbox: JQuery<HTMLElement>;
    private shipServSerialNumberCheckbox: JQuery<HTMLElement>;
    private shipServDrawingCheckbox: JQuery<HTMLElement>;
    private shipServDepartmentTypeCheckbox: JQuery<HTMLElement>;

    private linesTable : JQuery<HTMLElement>;
    private linesTableBody : JQuery<HTMLElement>;

    public initialize() {
        this.bindElements();
        this.bindEvents();
    }

    private bindElements() {
        var self = this;

        self.amountOfSelectedLinesTextSpan = self.containerElement.find('#amount-of-to-be-changed-lines-text');
        self.selectAllLinesCheckbox = this.containerElement.find('#select-all-checkbox');

        self.equipmentSectionOptionsContainer = this.containerElement.find('#equipment-section-options-container');
        self.selectAllEquipmentSectionButton = this.containerElement.find('#select-all-equipment-section-items-button');
        self.selectNoneEquipmentSectionButton = this.containerElement.find('#select-none-equipment-section-items-button');

        self.restoreOriginalDescriptionButton = this.containerElement.find('#restore-original-description-button');
        self.updateDescriptionButton = this.containerElement.find('#update-description-button');

        self.shipServNameCheckbox = this.containerElement.find('#shipserv-name-checkbox');
        self.shipServDescriptionCheckbox = this.containerElement.find('#shipserv-description-checkbox');
        self.shipServManufacturerCheckbox = this.containerElement.find('#shipserv-manufacturer-checkbox');
        self.shipServModelNumberCheckbox = this.containerElement.find('#shipserv-model-number-checkbox');
        self.shipServRatingCheckbox = this.containerElement.find('#shipserv-rating-checkbox');
        self.shipServSerialNumberCheckbox = this.containerElement.find('#shipserv-serial-number-checkbox');
        self.shipServDrawingCheckbox = this.containerElement.find('#shipserv-drawing-checkbox');
        self.shipServDepartmentTypeCheckbox = this.containerElement.find('#shipserv-department-type-checkbox');

        self.linesTable = this.containerElement.find('#lines-table');
        self.linesTableBody = self.linesTable.find('tbody');
    }

    private bindEvents() {
        var self = this;

        self.selectAllEquipmentSectionButton.off('click').on('click', () => {
            self.equipmentSectionOptionsContainer.find('input[type="checkbox"]').prop( "checked", true);
        })

        self.selectNoneEquipmentSectionButton.off('click').on('click', () => {
            self.equipmentSectionOptionsContainer.find('input[type="checkbox"]').prop( "checked", false);
        })

        self.selectAllLinesCheckbox.off('change').on('change', () => {
            var isChecked = self.selectAllLinesCheckbox.is(':checked');
            self.linesTableBody.find('input[type="checkbox"]').prop( "checked", isChecked);
            self.updateTotalSelectedCount();
        })

        self.linesTableBody.find('tr').off('click').on('click', (e) => {
            if(!$(e.target).is('input:checkbox')) {
                e.preventDefault();
                e.stopImmediatePropagation();

                var checkbox = $(e.currentTarget).find('input[type="checkbox"]');
                checkbox.prop('checked', !checkbox.is(":checked"));
            }

            self.checkboxChanged();
        })

        self.restoreOriginalDescriptionButton.off('click').on('click', () => {

            self.linesTableBody.find('tr').has('input[type="checkbox"]:checked').each((index, element) => {
                var tableRowToUpdate = $(element);

                var originalDescription = tableRowToUpdate.data('original-description');
                tableRowToUpdate.find('[data-description-td]').text(originalDescription);

                var hiddenDescriptionInput = tableRowToUpdate.find('input:hidden[name$=".Description"]');

                hiddenDescriptionInput.val(originalDescription);
            })

            self.selectAllLinesCheckbox.prop( "checked", false);
            self.linesTableBody.find('input[type="checkbox"]').prop( "checked", false);
            self.updateTotalSelectedCount();
        })        
        
        self.updateDescriptionButton.off('click').on('click', () => {

            var shipServNameChecked = self.shipServNameCheckbox.is(":checked");
            var shipServDescriptionChecked = self.shipServDescriptionCheckbox.is(":checked");
            var shipServManufacturerChecked = self.shipServManufacturerCheckbox.is(":checked");
            var shipServModelNumberChecked = self.shipServModelNumberCheckbox.is(":checked");
            var shipServRatingChecked = self.shipServRatingCheckbox.is(":checked");
            var shipServSerialNumberChecked = self.shipServSerialNumberCheckbox.is(":checked");
            var shipServDrawingChecked = self.shipServDrawingCheckbox.is(":checked");
            var shipServDepartmentTypeChecked = self.shipServDepartmentTypeCheckbox.is(":checked");

            self.linesTableBody.find('tr').has('input[type="checkbox"]:checked').each((index, element) => {
                var tableRowToUpdate = $(element);
                var originalDescription = tableRowToUpdate.data('original-description');

                var newDescription = originalDescription;

                var addToDescription = (checked, dataAttribute, textKey) => {
                    if(checked) {
                        var dataAttributeValue = tableRowToUpdate.data(dataAttribute)?.toString();
                        if(dataAttributeValue != undefined && dataAttributeValue.length > 0) {
                            newDescription += ` ^[${textKey}: ${dataAttributeValue} /]`
                        }
                    }
                }

                addToDescription(shipServNameChecked, 'shipserv-name', 'For');
                addToDescription(shipServDescriptionChecked, 'shipserv-description', 'Descr');
                addToDescription(shipServManufacturerChecked, 'shipserv-manufacturer', 'Man');
                addToDescription(shipServModelNumberChecked, 'shipserv-model-number', 'Model');
                addToDescription(shipServRatingChecked, 'shipserv-rating', 'Rating');
                addToDescription(shipServSerialNumberChecked, 'shipserv-serial-number', 'Serial');
                addToDescription(shipServDrawingChecked, 'shipserv-drawing-number', 'Drawing');
                addToDescription(shipServDepartmentTypeChecked, 'shipserv-department-type', 'Dept type');


                tableRowToUpdate.find('[data-description-td]').text(newDescription);

                var hiddenDescriptionInput = tableRowToUpdate.find('input:hidden[name$=".Description"]');

                hiddenDescriptionInput.val(newDescription);
            })



            self.selectAllLinesCheckbox.prop( "checked", false);
            self.linesTableBody.find('input[type="checkbox"]').prop( "checked", false);
            self.updateTotalSelectedCount();
            
        })

    }


    private updateTotalSelectedCount() {
        var self = this;

        self.amountOfSelectedLinesTextSpan.text(self.linesTableBody.find('input[type="checkbox"]:checked').length)
    }

    private checkboxChanged() {
        var self = this;

        var allChecked = self.linesTableBody.find('input[type="checkbox"]:checked').length == self.linesTableBody.find('input[type="checkbox"]').length;
        
        self.selectAllLinesCheckbox.prop('checked', allChecked);
        self.updateTotalSelectedCount();
    }


}